import React, { useState, useEffect, useContext } from 'react';
import axios from "../../../../axios/index"

import { UserContext } from '../../../Context/UserContextProvider';

import { Form } from 'react-bootstrap';
import ShowProfileModal from '../../DashboardFileManagement/CardDetail/ShowProfileModal';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import { Link, useLocation } from 'react-router-dom';

// Styles
import styles from "./../Settings.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const SettingContactMessagesDetail = () => {
    const { userToken } = useContext(UserContext);
    const [modalShow, setModalShow] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { state } = useLocation();
    const history = useHistory();

    const [formMessageValue, setFormMessageValue] = useState({
        fullName: "",
        company: "",
        email: "",
        callNumber: "",
        message: "",
    })

    // // Change Value Forms Contact
    // const formMessageChangeHandler = (e) => {
    //     setFormMessageValue({
    //         ...formMessageValue,
    //         [e.target.name]: e.target.value,
    //     });
    // }

    useEffect(() => {
        const dataHandler = async () => {
            // setIsLoading(true)
            const getContactedData = await axios.get(
                `ContactUs/${state.id}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            const messages = getContactedData.data.data;
            setFormMessageValue((prev) => {
                return { ...prev, fullName: messages.fullName, company: messages.subject, email: messages.email, callNumber: messages.phoneNumber, message: messages.messageBody }
            });
            setIsLoading(false)
        }

        dataHandler()
    }, [userToken, state.id])

    return (
        <>
            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            {isLoading ? (
                <div className={Dstyles.loader_container} >
                    <div className={Dstyles.spinner}></div>
                </div >
            )
                : (
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                                    <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                        dir="rtl"
                                    >
                                        <div className='d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                            <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                            <div className={styles.text1}>
                                                تماس با ما
                                            </div>
                                        </div>
                                    </div>

                                    <div dir="rtl" className={`text-right mx-4 px-2 mt-4 mb-3`}>
                                        <div className={`d-flex justify-content-between align-items-start flex-wrap mt-2 py-2`}>
                                            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                                <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="fullName"> نام و نام خانوادگی </Form.Label>
                                                <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="fullName" name="fullName" value={formMessageValue.fullName} />
                                            </Form.Group>
                                            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                                <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="company"> شرکت (اختیاری) </Form.Label>
                                                <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="company" name="company" value={formMessageValue.company} />
                                            </Form.Group>
                                            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                                <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="email"> ایمیل </Form.Label>
                                                <Form.Control className={`${styles.form_control_input} shadow-none`} type="email" id="email" name="email" value={formMessageValue.email} />
                                            </Form.Group>
                                            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                                <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="callNumber"> شماره تماس </Form.Label>
                                                <Form.Control className={`${styles.form_control_input} shadow-none`} type="tel" id="callNumber" name="callNumber" value={formMessageValue.callNumber} />
                                            </Form.Group>
                                            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column w-100`}>
                                                <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="message"> پیام </Form.Label>
                                                <Form.Control style={{ resize: "none" }} className={`${styles.form_control_input} shadow-none`} as="textarea" rows={5} id="message" name="message" value={formMessageValue.message} />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu />
                                {/* sideMenu ends */}
                            </div>
                        </div>
                    </div>
                )}
        </>
    )
}

export default SettingContactMessagesDetail;